import { createSelector } from "reselect";
import getSchoolSelector from "./getSchoolSelector";

export default createSelector(getSchoolSelector, school => school.post_title);
